/**
 * LTP link destinations (US market). Source: portal_web/docs/ltp-requirements.md (Terms/Policy Links).
 * Terms: EN/ES are separate exports so each locale can be updated independently.
 */
export const LTP_URL_TERMS_EN = 'https://policies.warnerbros.com/terms/en-us/';

export const LTP_URL_TERMS_ES = 'https://policies.warnerbros.com/terms/en-us/';

export const LTP_URL_PRIVACY_EN = 'https://www.wbdprivacy.com/policycenter/b2c/en-us';

export const LTP_URL_PRIVACY_ES = 'https://www.wbdprivacy.com/policycenter/b2c/es-us/';

export const LTP_URL_US_STATE_SUPPLEMENT_EN = 'https://www.wbdprivacy.com/policycenter/usstatesupplement/en-us/';

export const LTP_URL_US_STATE_SUPPLEMENT_ES = 'https://www.wbdprivacy.com/policycenter/usstatesupplement/es-us/';
